<div class="add-photo-dialog p-4 bg-white rounded-4" style="max-width: 490px; width: 100%;">
  <!-- Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <div class="dialog-header-icon">
        <mat-icon>photo_camera</mat-icon>
      </div>
      <div>
        <h3 class="dialog-title mb-0 fw-bold">Add Issue Photo</h3>
        <p class="dialog-subtitle mb-0">Upload evidence photos for this request.</p>
      </div>
    </div>
    <button type="button" mat-icon-button class="dialog-close-btn flex-shrink-0" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-progress-bar *ngIf="submitting" mode="indeterminate"></mat-progress-bar>

    <div class="form-section">
      <div class="dialog-section-bar mb-3">
        <div class="section-icon-circle">
          <mat-icon>photo_camera</mat-icon>
        </div>
        <h4 class="section-bar-title mb-0">Upload Photo</h4>
      </div>

      <div class="form-group form-group--full">
        <label class="form-label small fw-semibold text-secondary mb-1">Issue Photo</label>
        <div
          class="upload-zone"
          [class.drag-over]="isDragOver"
          (click)="triggerFileInput(fileInput)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p class="upload-text">Click to upload or drag and drop</p>
          <p class="upload-hint">Supported: image files</p>
          <input
            #fileInput
            type="file"
            class="file-input"
            accept="image/*"
            (change)="onFileSelect($event)" />
        </div>
      </div>

      <div *ngIf="issuePhotoPreview" class="preview-card mt-3">
        <div class="preview-image-wrap">
          <img [src]="issuePhotoPreview" alt="Issue photo preview" class="preview-image" />
        </div>
        <div class="preview-info">
          <div class="preview-details">
            <mat-icon>image</mat-icon>
            <span class="preview-name">{{ issuePhoto?.name || 'Selected image' }}</span>
          </div>
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="deleteFile(); $event.stopPropagation()"
            matTooltip="Remove image">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-actions d-flex justify-content-end gap-2 pt-3 border-top mt-3">
    <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="closeDialog()">
      Cancel
    </button>
    <button
      type="button"
      class="gold-button"
      (click)="onSubmit()"
      [disabled]="!issuePhotoPreview || submitting">
      <span *ngIf="!submitting">Upload Photo</span>
      <span *ngIf="submitting">Uploading...</span>
    </button>
  </div>
</div>
